import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateEditContent from './CreateEditContent';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import {
  SLEditModal,
  SLCreateModal,
} from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function GrupoPerfil() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));
    }

    handleRequests();
    api.get('/signed/cliente/administracao/organizacao/unidades').then(response => setUnidades(response.data));
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get('/signed/cliente/administracao/gerenciamento/gruposperfis'),
              findOne: thisData =>
                api.get('/signed/cliente/administracao/gerenciamento/grupoperfil', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/cliente/administracao/gerenciamento/grupoperfil', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Grupos de Perfil',
              icone: 'submenu-grupos',
            }}
            pageSize={8}
            inputs={[
              { filter: 'nome', label: 'Nome' },
              { filter: 'id', label: 'Id' },
            ]}
          >
            <SLEditModal title="Atualizar Grupo de Perfil" setter={setMountedData}>
              {mountedData && modulos && (
                <CreateEditContent {...{ unidades, modulos, mountedData }} />
              )}
            </SLEditModal>

            <SLCreateModal title="Adicionar Grupo de Perfil">
              {modulos && <CreateEditContent {...{ modulos, unidades }} />}
            </SLCreateModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
